import type { ICMSAliasViewModel } from './cms-alias.viewModel.types';
import type { CMSAlias } from '@/src/cms/domain/models/cms-alias';


export class CMSAliasViewModel implements ICMSAliasViewModel {
  readonly $type = 'alias' as const;

  url: ICMSAliasViewModel['url'];

  language: ICMSAliasViewModel['language'];

  constructor(data: { url: string; language: ICMSAliasViewModel['language'] }) {
    this.url = data.url;
    this.language = data.language;
  }

  static presenter(entity: CMSAlias): CMSAliasViewModel {
    return new CMSAliasViewModel({
      url: entity.url,
      language: entity.language
    });
  }
}
